import React from 'react';
import { Button, Grid } from '@material-ui/core';
import copies from './copies';
import styles from './ReturnToApp.module.css';

const ReturnToApp = () => (
  <div>
    <Grid item xs={12}>
      <p className={styles.paragraph}>{copies.message}</p>
    </Grid>
    <Grid item xs={12}>
      <Button
        className={styles.button}
        variant="contained"
        type="button"
        href="https://link.fondeadora.app/open"
      >
        {copies.returnButton}
      </Button>
    </Grid>
  </div>
);
export default ReturnToApp;
